<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight" :lang="lang.Right"></Right>
 </div>
</template>

<script>
import Left from '@/components/LibraryManager/Views/LibraryTable/Left/Left'
import Middle from '@/components/LibraryManager/Views/LibraryTable/Middle/Middle'
import Right from '@/components/LibraryManager/Views/LibraryTable/Right/Right'
import { mapGetters } from 'vuex'

export default {
  name: 'LibraryTable',
  components:{
    Left,
    Middle,
    Right
  },
  props:{
    lang: Object
  },
  computed:{
    ...mapGetters([
        'isPlugin',
       
      ]),
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  mounted () {
    
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable.vue